<template>
    <Header v-if="!isModal"></Header>
    <article :class="isModal ? 'main' : 'main limit-width'">
        <Navbar href="/inventaire" class="row" v-if="!isModal">
            <template #back>vers inventaire</template>
            <template #title>Inventaire&nbsp;:&nbsp;{{ computer?.pc_name }}</template>
        </Navbar>
        <div class="alerts-container">
            <button class="debug-alert" @click="addAlert('Success', 'success-alert')" v-if="debug_mode">Show Alert</button>
            <div class="alerts-wrapper">
                <Alert
                    v-for="alert in alerts"
                    :key="alert.id"
                    :class="alert.class"
                    @closed="removeAlert(alert.id)"
                >
                {{ alert.message }}
                </Alert>
            </div>
        </div>
        <section class="section btn-section">
            <div class="button-group">
                <button
                    class="primary-button-outlined"
                    @click="downloadPDF"
                    title="PDF pour l'impression des labels"
                >
                    <i class="material-icons">download</i>&nbsp;Télécharger PDF
                </button>
                
                <button :class="editMode ? 'danger-button' : 'primary-button-outlined'" @click="editMode = !editMode">
                    <i class="material-icons">{{ !editMode ? 'edit' : 'cancel' }}</i>&nbsp;{{ !editMode ? 'Éditer' : 'Annuler édition' }}
                </button>
                <button class="success-button-discret" v-if="editMode" @click="updateInventory">
                    <i class="material-icons">save</i>&nbsp;Sauvegarder
                </button>
            </div>
            <router-link
                class="primary-button-outlined"
                :to="{ name: 'InventoryItemDetail', params: { url_token: computer?.url_token }, state: { computer: props.computer } }"
                title="Ouvrir les détails dans une nouvelle fenêtre"
                v-if="isModal"
            >
                <i class="material-icons">open_in_full</i>&nbsp;Ouvrir
            </router-link>
        </section>
        <section class="section">
            <Sub_InventoryScoring :computer="computer?.latest_benchmark"></Sub_InventoryScoring>
        </section>
        <div class="dual-display">
            <section class="section">
                <div class="grid grid-x-2">
                    <p class="bold">Affectation actuelle</p>
                    <select v-model="draftComputer.current_affectation" v-if="editMode && draftComputer.current_affectation != 'manualInput'">
                        <optgroup label="Actuellement dans la base de données">
                            <option :value="computer.current_affectation">{{ computer.current_affectation }}</option>
                        </optgroup>
                        <optgroup label="Autres">
                            <option value="En stock" v-if="computer.current_affectation != 'En stock'">En stock</option>
                            <option value="Jeté" v-if="computer.current_affectation != 'En stock'">Jeté</option>
                            <option value="manualInput">Saisie manuelle</option>
                            <option :value="manualAffectation" v-if="draftComputer.current_affectation == manualAffectation">{{ manualAffectation }}</option>
                        </optgroup>
                        <optgroup label="Conseiller disponibles">
                            <template v-for="conseiller in usersList">
                                <option :value="conseiller.last_name + ' ' + conseiller.first_name" v-if="computer.current_affectation != conseiller.last_name + ' ' + conseiller.first_name">{{ conseiller.last_name + ' ' + conseiller.first_name }}</option>
                            </template>
                        </optgroup>
                    </select>
                    <div v-else-if="editMode && draftComputer.current_affectation == 'manualInput'">
                        <input type="text" placeholder="Nouvelle affectation" v-model="manualAffectation">
                        <div class="dual-button">
                            <button class="primary-button" @click="draftComputer.current_affectation = manualAffectation"><i class="material-icons">check_circle</i>&nbsp;Valider</button>
                            <button class="danger-button" @click="draftComputer.current_affectation = computer.current_affectation"><i class="material-icons">cancel</i>&nbsp;Annuler</button>
                        </div>
                    </div>
                    <p class="bold" v-else>{{ draftComputer?.current_affectation || "N/A" }}</p>


                    <p class="bold" v-if="editMode" >Permanent ?</p>
                    <p v-else class="bold">Permanent/Temporaire</p>
                    <SwitchButton 
                        v-model:checked="draftComputer.affectation_is_permanent"
                        v-if="editMode"
                    >
                    </SwitchButton>
                    <p v-else>
                        <template v-if="computer?.affectation_is_permanent">
                            Permanent
                        </template>
                        <template v-else>
                            <p style="font-weight: bold;color: brown;">Temporaire</p>
                        </template>
                    </p>
    
                    <p class="bold">Nom de l'appareil</p>
                    <input type="text" v-model="draftComputer.pc_name" v-if="editMode">
                    <p class="bold" v-else>{{ computer?.pc_name || "N/A" }}</p>
    
                    <p>Fabricant</p>
                    <input type="text" v-model="draftComputer.manufacturer" v-if="editMode">
                    <p v-else>{{ computer?.manufacturer || "N/A" }}</p>
    
                    <p>Modèle</p>
                    <input type="text" v-model="draftComputer.model" v-if="editMode">
                    <p v-else>{{ computer?.model || "N/A" }}</p>
    
                    <p>Numéro de série</p>
                    <p>{{ computer?.serial_number || "N/A" }}</p>
    
                    <p>Adresse MAC</p>
                    <p>{{ computer?.mac_address || "N/A" }}</p>
    
                    <p>Version du système</p>
                    <input type="text" v-model="draftComputer.os_version" v-if="editMode">
                    <p v-else>{{ computer?.os_version || "N/A" }}</p>
    
                    <p>Date d'entrée en stock</p>
                    <p>{{ new Date(computer?.created_at).toLocaleString('fr-FR') || "N/A" }}</p>
    
                    <p>Dernière actualisation</p>
                    <p>{{ new Date(computer?.last_audit).toLocaleString('fr-FR') || "N/A" }}</p>
                </div>
            </section>
            <section class="section">
                <div class="grid grid-x-2">
                    <p>Nom du CPU</p>
                    <input type="text" v-model="draftComputer.hardware_specs.cpu_name" v-if="editMode">
                    <p v-else>{{ computer?.hardware_specs?.cpu_name || "N/A" }}</p>
    
                    <p>Nombre de cœurs</p>
                    <input type="number" v-model="draftComputer.hardware_specs.cpu_cores" v-if="editMode">
                    <p v-else>{{ computer?.hardware_specs?.cpu_cores || "N/A" }}</p>
    
                    <p>Nombre de threads</p>
                    <input type="number" v-model="draftComputer.hardware_specs.cpu_threads" v-if="editMode">
                    <p v-else>{{ computer?.hardware_specs?.cpu_threads || "N/A" }}</p>
    
                    <p>Fréquence CPU (MHz)</p>
                    <input type="number" v-model="draftComputer.hardware_specs.cpu_clock_mhz" v-if="editMode">
                    <p v-else>{{ computer?.hardware_specs?.cpu_clock_mhz || "N/A" }}</p>
    
                    <p>Architecture</p>
                    <input type="text" v-model="draftComputer.hardware_specs.cpu_architecture" v-if="editMode">
                    <p v-else>{{ computer?.hardware_specs?.cpu_architecture || "N/A" }}</p>
    
                    <p>RAM (Go)</p>
                    <input type="number" v-model="draftComputer.hardware_specs.ram_gb" v-if="editMode">
                    <p v-else>{{ computer?.hardware_specs?.ram_gb || "N/A" }}</p>
    
                    <p>Type de RAM</p>
                    <input type="text" v-model="draftComputer.hardware_specs.ram_type" v-if="editMode">
                    <p v-else>{{ computer?.hardware_specs?.ram_type || "N/A" }}</p>
    
                    <p>Nom du GPU</p>
                    <input type="text" v-model="draftComputer.hardware_specs.gpu_name" v-if="editMode">
                    <p v-else>{{ computer?.hardware_specs?.gpu_name || "N/A" }}</p>
    
                    <p>Mémoire GPU</p>
                    <input type="number" v-model="draftComputer.hardware_specs.gpu_memory" v-if="editMode">
                    <p v-else>{{ computer?.hardware_specs?.gpu_memory || "N/A" }}</p>
    
                    <p>Modèle du disque</p>
                    <input type="text" v-model="draftComputer.hardware_specs.disk_model" v-if="editMode">
                    <p v-else>{{ computer?.hardware_specs?.disk_model || "N/A" }}</p>
    
                    <p>Stockage principal</p>
                    <input type="text" v-model="draftComputer.hardware_specs.primary_storage" v-if="editMode">
                    <p v-else>{{ computer?.hardware_specs?.primary_storage || "N/A" }}</p>
    
                    <p>SSD</p>
                    <SwitchButton 
                        v-model:checked="draftComputer.hardware_specs.is_ssd"
                        v-if="editMode"
                    >
                    </SwitchButton>
                    <p v-else>{{ computer?.hardware_specs?.is_ssd ? "Oui" : "Non" }}</p>
    
                    <p>Taille totale du stockage (Go)</p>
                    <input type="number" v-model="draftComputer.hardware_specs.size_gb" v-if="editMode">
                    <p v-else>{{ computer?.hardware_specs?.size_gb || "N/A" }}</p>
    
                    <p>Stockage disponible (Go)</p>
                    <input type="number" v-model="draftComputer.hardware_specs.free_gb" v-if="editMode">
                    <p v-else>{{ computer?.hardware_specs?.free_gb || "N/A" }}</p>
    
                    <p>Stockage disponible (%)</p>
                    <input type="number" v-model="draftComputer.hardware_specs.free_percent" v-if="editMode">
                    <p v-else>{{ computer?.hardware_specs?.free_percent || "N/A" }}</p>
    
                    <p>État SMART</p>
                    <input type="text" v-model="draftComputer.hardware_specs.smart_status" v-if="editMode">
                    <p v-else>{{ computer?.hardware_specs?.smart_status || "N/A" }}</p>
    
                    <p>Taille de l'écran (pouces)</p>
                    <input type="number" v-model="draftComputer.hardware_specs.screen_inches" v-if="editMode">
                    <p v-else>{{ computer?.hardware_specs?.screen_inches || "N/A" }}</p>
                </div>
            </section>
        </div>
        <section class="section">
            <Sub_InventoryAffectationHistoryTable ref="historyTable" :computerId="computerId"></Sub_InventoryAffectationHistoryTable>
        </section>
    </article>
</template>

<script setup>
import { reactive, onMounted, watch, ref, computed } from 'vue'
import { useRoute }                        from 'vue-router'
import SwitchButton                        from '@/components/SwitchButton.vue'
import Navbar                              from '@/components/Navbar.vue'
import Header                              from '@/components/Header.vue'
import Alert                               from '@/components/Alert.vue'
import apiClient                           from '@/api'
import jsPDF                               from 'jspdf'
import Sub_InventoryAffectationHistoryTable from './Sub_InventoryAffectationHistoryTable.vue'
import Sub_InventoryScoring from './Sub_InventoryScoring.vue'

const props = defineProps({
    computer: Object,
    isModal: { type: Boolean, default: false }
})

const route         = useRoute()
const computer      = reactive(props.computer || route.state?.computer || {})
const draftComputer = reactive({})

const editMode          = ref(false)
const usersList         = ref([])
const manualAffectation = ref('')
const debug_mode        = ref(false)
const historyTable      = ref(null)

const computerId = computed(() => computer?.id)

// alert handler start
const alerts = ref([])
let idCounter = 0

const addAlert = (message, alertClass) => {
    const existingIndex = alerts.value.findIndex(a => a.message === message)

    // If alert already exists
    if (existingIndex !== -1) {
        const existingAlert = alerts.value[existingIndex]

        // Remove it from its current position
        alerts.value.splice(existingIndex, 1)

        // Force re-render (restart animation & timer)
        idCounter++
        existingAlert.id = idCounter
        existingAlert.class = alertClass

        // Add it back at the top
        alerts.value.unshift(existingAlert)
        return
    }

    // Otherwise create a new alert
    idCounter++

    alerts.value.unshift({
        id: idCounter,
        class: alertClass,
        message: message
    })
}

const removeAlert = (id) => {
    alerts.value = alerts.value.filter(a => a.id !== id)
}
// alert handler end


const downloadPDF = async () => {
    // Create 80mm x 50mm PDF. Units = mm.
    const width  = 80
    const height = 50
    const margin = 3
    const doc    = new jsPDF({
        unit: 'mm',
        format: [width, height],
        orientation: 'landscape'
    })

    // QR CODE (top-left)
    const qrSize = 21
    const qrX    = margin
    const qrY    = 3.5

    // Generate QR CODE
    console.log(`inventaire/detail/${computer.url_token}`)
    const response = await apiClient.get('generate_qr/', { params : { url: `/inventaire/detail/${computer.url_token}` } })
    
    // add QR Code from backend
    if (response.data.data) {
        doc.addImage(response.data.data, "PNG", qrX, qrY, qrSize, qrSize)
    }

    // IMAGE (bottom-right, same size as QR code)
    const imgSize = 10 
    const imgX    = width  - imgSize - 4
    const imgY    = qrY
    const bgeLogo = document.getElementById('bge-logo')
    if(bgeLogo) {
        doc.addImage(bgeLogo, "PNG", imgX, imgY, imgSize, imgSize)
    }

    // Spacing
    let x_right_qr  = qrX + qrSize + 2  // 2mm spacing from QR code
    let x_left      = margin
    let x_right     = width - margin
    let y           = margin + 2.5
    let lineSpacing = 3.5

    // Computer Section
    doc.setFont("helvetica", "bold")
    doc.setFontSize(7)
    doc.text("Ordinateur", x_right_qr, y)
    y += lineSpacing
    doc.setFont("helvetica", "normal")
    doc.setFontSize(6.5)
    doc.text(`Nom : ${computer?.pc_name || "N/A"}`, x_right_qr, y)
    y += lineSpacing
    doc.text(`Fabricant : ${computer?.manufacturer || "N/A"}`, x_right_qr, y)
    y += lineSpacing
    doc.text(`Modèle : ${computer?.model || "N/A"}`, x_right_qr, y)
    y += lineSpacing
    doc.text(`Numéro de série : ${computer?.serial_number || "N/A"}`, x_right_qr, y)
    y += lineSpacing
    doc.text(`Adresse MAC : ${computer?.mac_address || "N/A"}`, x_right_qr, y)
    y += 3

    // Horizontal line
    doc.setDrawColor(0)
    doc.setLineWidth(0.2)
    doc.line(x_left, y, x_right, y)
    y += 4

    // Hardware Section (same as before)
    doc.setFont("helvetica", "bold")
    doc.setFontSize(7)
    doc.text("Spécifications", x_left, y)
    // doc.text(`Score : ${computer?.latest_benchmark?.overall_score} / 600`, x_right, y, { align: "right" })
    y += lineSpacing
    doc.setFont("helvetica", "normal")
    doc.setFontSize(6.5)
    doc.text(`CPU : ${computer?.hardware_specs?.cpu_name || "N/A"}`, x_left, y)
    // if (computer?.latest_benchmark?.cpu_score != null) {
    //     doc.text(`${computer.latest_benchmark.cpu_score} / 400`, x_right, y, { align: "right" });
    // }
    y += lineSpacing
    doc.text(`RAM : ${computer?.hardware_specs?.ram_gb || "N/A"} Go ${computer?.hardware_specs?.ram_type || "N/A"}`, x_left, y)
    // if (computer?.latest_benchmark?.memory_score != null) {
    //     doc.text(`${computer.latest_benchmark.memory_score} / 150`, x_right, y, { align: "right" });
    // }
    y += lineSpacing
    doc.text(`GPU : ${computer?.hardware_specs?.gpu_name || "N/A"}`, x_left, y)
    // if (computer?.latest_benchmark?.gpu_score != null) {
    //     doc.text(`${computer.latest_benchmark.gpu_score} / 150`, x_right, y, { align: "right" });
    // }
    y += lineSpacing
    doc.text(`Disque : ${computer?.hardware_specs?.size_gb} Go ${computer?.hardware_specs?.is_ssd ? 'SSD' : 'HDD' || "N/A"}`, x_left, y)
    // if (computer?.latest_benchmark?.storage_score != null) {
    //     doc.text(`${computer.latest_benchmark.storage_score} / 4`, x_right, y, { align: "right" });
    // }
    y += lineSpacing
    // if (computer?.latest_benchmark?.overall_score != null) {
    //     doc.text(`Score global : ${computer.latest_benchmark.overall_score} / 600`, x_right, y, { align: "right" })
    // }
    // vertical date
    doc.setFontSize(5.5)
    const inventoryText = `Inventorié le : ${computer?.last_audit ? new Date(computer.last_audit).toLocaleDateString() : new Date().toLocaleDateString()}`;
    const textHeight = doc.getTextDimensions(inventoryText).w; // rotated text width = vertical height
    doc.text(
        inventoryText,
        width - 1,                        // X
        (height / 2) + (textHeight / 2),  // Y
        { angle: 90, align: "left" }
    )

    // Download
    doc.save(`${computer?.pc_name || "pc"}.pdf`)
}

const getChangedFieldsDeep = (original, draft) => {
    const changes = {}

    for (const key in draft) {
        const originalValue = original[key]
        const draftValue    = draft[key]

        if (typeof draftValue == "object" && draftValue !== null && !Array.isArray(draftValue)) {
            const nestedChanges = getChangedFieldsDeep(originalValue || {}, draftValue)

            if (Object.keys(nestedChanges).length > 0) {
                changes[key] = nestedChanges
            }
        } else if (draftValue !== originalValue) {
            changes[key] = draftValue
        }
    }

    return changes
}


const updateInventory = async () => {
    console.log('Computer Object : ',computer)
    console.log('draftComputer Object : ',draftComputer)
    console.log('Token : ', computer.url_token)

    const changedData = getChangedFieldsDeep(computer, draftComputer);

    if (Object.keys(changedData).length == 0) {
        console.log("Aucun changement à sauvegarder !")
        addAlert("Aucun changement à sauvegarder !", 'warning-alert')
        return
    }

    const params = {
        changedData: changedData,
        url_token: computer.url_token,
    }

    try {
        const response = await apiClient.post('update_inventory/', params)

        getInventoryItem(params.url_token)
        console.log('Status : ', response.status)
        console.log(response.data.message)
        addAlert(response.data.message, 'success-alert')
        editMode.value = !editMode.value

    } catch (error) {
        if (error.response) {
            console.log(error.response.status)
            console.log(error.response.data.message)
            addAlert(error.response.data.message, 'danger-alert')
        } else if (error.request) {
            console.log(error.request)
        } else {
            console.log(error.message)
        }
    }

    if (historyTable.value) historyTable.value.refetch()
}

const getInventoryItem = async (url_token) => {
    try {
        const response = await apiClient.get('get_inventory_item/', { params: { url_token: url_token } })

        console.log('Status : ',response.status)
        console.log(response.data.message)
        addAlert(response.data.message, 'success-alert')

        Object.assign(computer, response.data.data)
    } catch (error) {
        if (error.response) {
            console.log(error.response.status)
            console.log(error.response.data.message)
            addAlert(error.response.data.message, 'danger-alert')
        } else if (error.request) {
            console.log(error.request)
        } else {
            console.log(error.message)
        }
    }
}

watch(editMode, (newVal) => {
    if(newVal) {
        Object.assign(draftComputer, JSON.parse(JSON.stringify(computer)))
    }
})

onMounted(async () => {
	debug_mode.value = import.meta.env.DEV

    if (!props.computer && !route.state?.computer && route.params.url_token) {
        getInventoryItem(route.params.url_token)
    }

    try {
        const response  = await apiClient.get('users_name_list/')
        usersList.value = response.data.data
        console.log('Status : ', response.status)
    } catch (error) {
        if(error.response) {
            console.log(error.response.status)
            console.log(error.response.data.message)
            addAlert(error.response.data.message, 'danger-alert')
        } else if (error.request) {
            console.log(error.request)
        } else {
            console.log(error.message)
        }
    }

    console.log(computer?.id)
})
</script>

<style lang="scss" scoped>
.main {
    box-sizing: border-box;

    background-color: #fff;
    border-radius: 6px;
    max-width: 95vw;
    margin: 1rem auto;
    padding: 1rem;

    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.bold {
    font-weight: bold;
}

.limit-width {
    width: max-content;
}

.section {
    border: 1px solid $platinium;
    border-radius: 6px;
    padding: 1rem;
}

.grid {
    display: inline-grid;
    align-items: center;
    column-gap: 2rem;
}

.grid-x-2 {
    grid-template-columns: 1fr 2fr;
}

.grid-x-5 {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
}

.button-group {
    display: inline-grid;
    grid-auto-columns: max-content;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 1rem;

    button {
        justify-content: center;
        width: 100%;
    }
}

.btn-section {
    display: flex;

    justify-content: space-between;
}

.alerts-wrapper {
    position: fixed;
    bottom: 1vh;
    right: 3vw;
    display: flex;
    flex-direction: column;
    flex-flow: column-reverse;
    gap: 0.5rem;
    z-index: 9999;

    align-items: end;

    margin-left: 3vw;
}

.dual-button {
    display: flex;
    gap: 1rem;
    justify-content: space-between;
    padding-top: 1rem;

    button {
        height: 34px;
    }
}

.dual-display {
    display: flex;

    gap: 1rem;

    width: 100%;

    .section {
        width: 100%;
    }
}
</style>